import { render, staticRenderFns } from "./PayQrcode.vue?vue&type=template&id=c38ecf30"
import script from "./PayQrcode.vue?vue&type=script&lang=js"
export * from "./PayQrcode.vue?vue&type=script&lang=js"
import style0 from "./PayQrcode.vue?vue&type=style&index=0&id=c38ecf30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports